import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { KbInfo } from '@medindex/helixru-web-api/dist/helixru-web-api';
import { HelixBookRepositoryService } from '../../services/helix-book-repository.service';
import { Subject, filter, takeUntil, BehaviorSubject } from 'rxjs';
import { HelixBookUtils } from '../../utils/helix-book-utils';

@Component({
  selector: 'app-anchor-list',
  templateUrl: './anchor-list.component.html',
  styleUrls: ['./anchor-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnchorListComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() info: KbInfo | null = null;
  @Input() isAnalyse = false;
  @ViewChildren('subject') subjectElements:
    | QueryList<ElementRef<HTMLElement>>
    | undefined;
  @ViewChild('anchorContainer') anchorContainer:
    | ElementRef<HTMLElement>
    | undefined;

  ngUnsubscribe$ = new Subject<void>();
  subjects$ = new BehaviorSubject<string[]>([]);

  constructor(public repository: HelixBookRepositoryService) {}

  ngOnInit(): void {
    this.subjects$.next(this._getSubjectsArray());
  }

  ngAfterViewInit(): void {
    this.repository.activeSubject$
      .pipe(
        filter((subjectId) => subjectId !== undefined),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe(() => {
        const activeElement = this.subjectElements?.find((element) =>
          element.nativeElement.classList.contains('active')
        );

        if (activeElement) {
          const offsetTop = activeElement.nativeElement.offsetTop;

          this.anchorContainer?.nativeElement.scrollTo({
            top: offsetTop - 50,
            left: 0,
            behavior: 'smooth',
          });
        }
      });
  }

  setSubjectId(subjectId: number): void {
    this.repository.setActiveSubject(subjectId);
    this.repository.setScrollEvent(true);
  }

  private _getSubjectsArray(): string[] {
    if (!this.info) return [];

    const allInfo =
      (this.info.shortInfo ?? '') +
      (this.info.info ?? '') +
      this.info.interpretationInfo +
      this.info.additionalInfo;

    return HelixBookUtils.getItemSubjects(allInfo);
  }

  trackBy(index: number, anchor: string) {
    return anchor;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
